<div class="image-loader-container">

  <!-- Loading State -->
  @if (isLoading && !hasError) {
    <div class="loading-overlay"
      >
      <div class="loading-content">
        <i class="fas fa-spinner fa-spin"></i>
        <span class="loading-text">{{ loadingText | translate }}</span>
      </div>
    </div>
  }

  <!-- Error State -->
  @if (hasError) {
    <div class="error-overlay"
      >
      <div class="error-content">
        <i class="fas fa-exclamation-triangle"></i>
        <span class="error-text">{{ errorText | translate }}</span>
        <button class="btn btn-sm btn-outline-primary mt-2"
          (click)="retryLoad()">
          <i class="fas fa-redo"></i> {{ retryText | translate }}
        </button>
      </div>
    </div>
  }

  <!-- Image - cachedSrc varsa onu kullan -->
  @if (!isLoading && !hasError) {
    <img [src]="cachedSrc || imageUrl || src"
      [alt]="alt"
      [title]="title"
      [class]="className"
      [style.visibility]="isLoading || hasError ? 'hidden' : 'visible'"
      >
  }
</div>
